<template>
    <div class="col-sm-6">
        <div class="card root">
            <div class="card-header text-white bg-dark">
                Subscription
            </div>

            <div v-if="customer != null && plans != null" class="card-body">
                <div class="form-group">
                    <label>Plan</label>
                    <div class="input-group">
                        <input
                            :value="generatePlanString(customer.plan)"
                            class="form-control"
                            type="text"
                            disabled
                        />
                    </div>
                    <small class="form-text text-muted"
                        >From <b>{{ period_start }}</b> –– Renew
                        <b>{{ period_end }}</b>
                    </small>
                </div>

                <div class="form-group">
                    <label>Status</label>
                    <div class="input-group">
                        <input
                            :value="status"
                            class="form-control"
                            type="text"
                            disabled
                        />
                    </div>
                </div>

                <div class="form-group">
                    <label>Switch Plan</label>
                    <div class="input-group">
                        <select
                            v-model="new_plan_id"
                            :disabled="loading"
                            class="form-control"
                        >
                            <option
                                v-for="plan in plans"
                                :key="plan.id"
                                :value="plan.id"
                            >
                                {{ generatePlanString(plan.id) }}
                            </option>
                        </select>
                        <div class="input-group-append">
                            <button
                                :disabled="loading"
                                class="btn btn-danger text-white"
                                type="button"
                                @click="confirm('', changePlan)"
                            >
                                Change
                            </button>
                        </div>
                    </div>
                    <small class="form-text text-muted">
                        You can switch plan within 5 days after signup or renew
                    </small>
                </div>
            </div>

            <div v-if="status == 'active'" class="card-footer text-right">
                <button
                    :disabled="loading"
                    class="btn btn-danger text-white"
                    @click="
                        confirm(
                            'Your account will be disabled immediately',
                            cancelSub
                        )
                    "
                >
                    Cancel Subscription
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import superagent from 'superagent'
import prettyBytes from 'pretty-bytes'
import moment from 'moment'
import swal from 'sweetalert'

import { config, auth, response } from 'website-core'

export default {
    data() {
        return {
            customer: null,
            status: '',

            period_start: '',
            period_end: '',

            plans: null,
            new_plan_id: 0,

            loading: false,
        }
    },
    created() {
        this.getCustomer()
        this.getPlans()
    },
    methods: {
        getGateway(gateways) {
            for (var gateway in gateways) {
                return gateway
            }
            return
        },
        getCustomer() {
            var self = this

            superagent
                .get(config.url_api + '/customer')
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200 || !res.body) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    self.customer = res.body

                    var gateway_type = self.getGateway(self.customer.gateway)
                    if (!gateway_type) {
                        return ''
                    }

                    // status
                    self.status = self.customer.gateway[
                        gateway_type
                    ].sub.status.replace('_', ' ')

                    // get period
                    for (var key in self.customer.gateway) {
                        self.period_start = moment(
                            self.customer.gateway[key].sub.period_start
                        ).fromNow()
                        self.period_end =
                            self.status != 'active'
                                ? 'never'
                                : moment(
                                      self.customer.gateway[key].sub.period_end
                                  ).fromNow()
                    }

                    // card
                    self.card = self.customer.gateway[gateway_type].card
                    return
                })
        },
        getPlans() {
            var self = this

            superagent.get(config.url_api + '/plan').end(function(err, res) {
                if (response.ResHandle(err, res, function() {}, self.$router)) {
                    return
                }

                if (res.status != 200) {
                    response.ResShowErr(
                        'There was an unknown error. Please try again later'
                    )
                    return
                }

                var plans = res.body

                // format
                for (var i = 0; i < plans.length; i++) {
                    plans[i].quota = prettyBytes(plans[i].quota)
                }

                self.plans = plans
                return
            })
        },
        generatePlanString(id) {
            for (var i = 0; i < this.plans.length; i++) {
                var plan = this.plans[i]
                if (plan.id == id) {
                    return (
                        plan.name +
                        ' –– ' +
                        plan.quota +
                        ' –– $' +
                        plan.price / 100 +
                        ' per ' +
                        plan.interval
                    )
                }
            }

            return 'none'
        },
        confirm(text, callback) {
            swal({
                title: 'Are you sure?',
                text: text,
                dangerMode: true,
                buttons: true,
            }).then(value => {
                if (value) {
                    callback()
                }
            })
        },
        cancelSub() {
            var self = this

            self.loading = true
            superagent
                .del(config.url_api + '/customer/plan')
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    self.loading = false
                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    response.ResShowOK('Hope to see you again')
                    self.getCustomer()
                    return
                })
        },
        changePlan() {
            var self = this

            if (self.new_plan_id == 0) {
                response.ResShowErr('Please choose new plan')
                return
            }

            if (self.new_plan_id == self.customer.plan) {
                response.ResShowErr('Same plan')
                return
            }

            self.loading = true
            superagent
                .put(config.url_api + '/customer/plan')
                .type('form')
                .query(auth.getAuthQs())
                .send({ plan_id: self.new_plan_id })
                .end(function(err, res) {
                    self.loading = false
                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    response.ResShowOK('Welcome back!')
                    self.getCustomer()
                    return
                })
        },
    },
}
</script>

<style scoped>
.root {
    margin: 0.5rem 0;
}

.billing {
    margin: 1rem 0;
}

#stripe_card {
    margin: 1rem 1.3rem;
}

.StripeElement {
    background-color: white;
    padding: 8px 12px;
    border-radius: 0.25rem;
    border: 1px solid rgba(0, 0, 0, 0.125);
}

.StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
    border-color: #fa755a;
}

.StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
}
</style>
